import { type DayOfWeek } from 'schema-dts';

export const getSchemaDayOfweek = (dayName: string): DayOfWeek | undefined => {
	switch (dayName.toLowerCase()) {
		case 'mon':
			return 'Monday';
		case 'tue':
			return 'Tuesday';
		case 'wed':
			return 'Wednesday';
		case 'thu':
			return 'Thursday';
		case 'fri':
			return 'Friday';
		case 'sat':
			return 'Saturday';
		case 'sun':
			return 'Sunday';
	}
	return undefined;
};
